import './styles/ErrorSummary.css';

import { PureComponent } from 'react';

import get from 'lodash/get';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import handleEvent from 'utils/handleEvent';
import { withAppProps } from 'utils/react/withAppProps';
import { makeSelectContentSnapshot } from '../selectors';

@withAppProps
class ErrorsSummary extends PureComponent {
  static propTypes = {
    msg: PropTypes.object.isRequired,
    navigate: PropTypes.func.isRequired,
    exceptionsMsg: PropTypes.object.isRequired,
    snapshot: ImmutablePropTypes.map,
  };

  handleClickOnRow = (errType) =>
    handleEvent((e) => {
      e.preventDefault();
      const { navigate } = this.props;
      navigate(
        `/snapshot-management/errors?options=${JSON.stringify({ filters: { errorType: ['eq', errType] } })}`,
      );
    });

  render() {
    const { msg, exceptionsMsg, snapshot } = this.props;
    const errors = snapshot?.get('errors');
    if (!errors || !errors.size) {
      const noErr = get(msg, 'discovery.errorsSummary.noError', '');
      return (
        <div className='snapshots-errors-summary__no-error'>
          <h2 className='mb-5 mt-0'>{noErr}</h2>
          <div className='snapshots-errors-summary__no-error-image' />
        </div>
      );
    }

    return (
      <table className='snapshots-errors-summary__table table-striped'>
        <tbody>
          {errors.map((e) => {
            return (
              <tr
                key={e.get('errorType')}
                className='snapshots-errors-summary__row'
                onClick={this.handleClickOnRow(e.get('errorType'))}
              >
                <td className='snapshots-errors-summary__cell snapshots-errors-summary__cell--first'>
                  {get(
                    exceptionsMsg,
                    `Summary${e.get('errorType')}`,
                    get(exceptionsMsg, e.get('errorType'), e.get('errorType')),
                  )}
                </td>
                <td className='snapshots-errors-summary__cell snapshots-errors-summary__cell--last'>
                  {e.get('count')}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  snapshot: makeSelectContentSnapshot(),
});

export default connect(mapStateToProps)(ErrorsSummary);
